import React from 'react';
import workspaceQuery from '../../queries/product/ProductsStockLotWorkspaceQuery.graphql';
import listQuery from '../../queries/product/StockLotListQuery.graphql';
import { EntityType, IDropdownOptionRenderer } from '../../../@types/entityTypes';
import { ILotAttributeValue, IStockLot, Maybe } from '../../schema/p4types';
import { format } from 'date-fns';
import { ALLOW_VIEW, ALLOW_EDIT } from '../../../utils/OperationPermissions';

function lotVariables(props: any) {
  const { rowData, column } = props;
  let productId, warehouseId;
  if (column && column.options && column.options.dropdown) {
    warehouseId = column.options.dropdown.warehouseId;
    productId = rowData && rowData.product ? rowData.product.id : null;
  }
  return {
    productId,
    warehouseId,
  };
}

export const filterAndSortAttributes = (attrs: Array<Maybe<ILotAttributeValue>>) => {
  return attrs
    .filter((a) => {
      return a?.attributeConfig;
    })
    .sort((a, b) => a!.attributeConfig!.sortOrder - b!.attributeConfig!.sortOrder);
};

export const StockLotOptionRenderer = ({
  option,
  noAttributeText,
}: {
  option: Array<ILotAttributeValue> | Maybe<IStockLot>;
  noAttributeText?: string;
}) => {
  const filterAndSort = (unfilteredAttributes?: Array<Maybe<ILotAttributeValue>>) => {
    const filtered = filterAndSortAttributes(unfilteredAttributes ?? []);

    if (filtered.length === 0) {
      let desc = noAttributeText ?? 'No Attributes';

      if ((option as Maybe<IStockLot>)?.freeStock) {
        desc += ` (Free: ${(option as IStockLot).freeStock})`;
      }

      return desc;
    }

    let lotAttributes = filtered
      .map((attr) => {
        if (attr?.attributeConfig?.title === 'MOVEMENT_DATE') {
          return `Movement Date: ${format(new Date(attr.value as string), 'dd MMM yyyy')}`;
        } else if (attr?.attributeConfig?.title === 'BATCH') {
          return `Batch: ${attr.value}`;
        }
        return `${attr?.attributeConfig?.title}: ${attr?.value}`;
      })
      .join(', ');
    if ((option as Maybe<IStockLot>)?.freeStock) {
      lotAttributes += ` (Free: ${(option as IStockLot).freeStock})`;
    }

    return lotAttributes;
  };

  let attrs: Array<Maybe<ILotAttributeValue>>;
  if (Array.isArray(option)) {
    if (option.length !== 0) {
      attrs = [...option];
    } else {
      attrs = [];
    }
  } else if (option?.lotAttributeValues) {
    attrs = [...option.lotAttributeValues];
  } else {
    attrs = [];
  }

  return <span>{filterAndSort(attrs)}</span>;
};

const filterOption = (option: any, filterValue: any) => {
  if (filterValue === '') return true;
  if (option.lotAttributeValues.length === 0) {
    return false;
  }
  const attrs = [...option.lotAttributeValues];
  attrs.sort((a, b) => a.attributeConfig.sortOrder - b.attributeConfig.sortOrder);
  return attrs[0].value.indexOf(filterValue) !== -1;
};

const StockLot: EntityType = {
  type: 'StockLot',
  title: 'Bin Contents',
  formUrl: '/Products/StockLot/Attributes/',
  formTitle: 'Bin Contents',
  workspace: workspaceQuery,
  workspaceUrl: '/Products/StockControl/BinContents/Workspace/',
  dropdown: {
    query: listQuery,
    customVariables: lotVariables,
    valueKey: 'id',
    labelKey: 'level',
    optionRenderer: StockLotOptionRenderer as IDropdownOptionRenderer,
    valueRenderer: StockLotOptionRenderer as IDropdownOptionRenderer,
    filterOption: filterOption,
    selectModal: 'StockLotLookupModal',
  },
  screenReference: 'BIN_CONTENTS',
  operations: ALLOW_VIEW | ALLOW_EDIT,
};

export default StockLot;
